<template>
    <div class="page__mission">
        <div class="page__wrapper">
            <div class="fader"></div>

            <Preloader />

            <Header />
            <section class="mission">
                <div class="mission__wrap">
                    <h2 class="mission__title detectMobVisibility">
                        <span class="textHide sec_inst">
                            <span>{{ $t('mission.brand') }}</span>
                        </span>
                    </h2>
                    <p
                        class="mission__text textFade detectMobVisibility"
                        v-html="$t('mission.brand_text')"
                    ></p>
                </div>
                <div class="mission__wrap">
                    <h2 class="mission__title detectMobVisibility">
                        <span class="textHide sec_inst">
                            <span>{{ $t('mission.model') }}</span>
                        </span>
                    </h2>
                    <p
                        class="mission__text textFade detectMobVisibility"
                        v-html="$t('mission.model_text')"
                    ></p>
                </div>
                <div class="mission__wrap">
                    <h2 class="mission__title detectMobVisibility">
                        <span class="textHide sec_inst">
                            <span>{{ $t('mission.strategy') }}</span>
                        </span>
                    </h2>
                    <p
                        class="mission__text textFade detectMobVisibility"
                        v-html="$t('mission.strategy_text')"
                    ></p>
                </div>
                <div class="mission__wrap">
                    <h2 class="mission__title detectMobVisibility">
                        <span class="textHide sec_inst">
                            <span>{{ $t('mission.mission') }}</span>
                        </span>
                    </h2>
                    <p
                        class="mission__text textFade detectMobVisibility"
                        v-html="$t('mission.mission_text')"
                    ></p>
                </div>
            </section>
        </div>
        <Footer />
    </div>
</template>

<script>
import i18n from "../lang/lang";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Preloader from "@/components/preloader.vue";

export default {
    ComponentName: "brand_mission_strategy",
    components: {
        Header,
        Footer,
        Preloader
    },
    data() {
        return {
            curVue: this
        };
    },
    mounted() {
        var _this = this;

        $("body")
            .removeClass("hideTopBar")
            .addClass("lightBack scrolledPage aboutPage faderOut");

        if ($("body").hasClass("aboutPage")) {
            var scrollDelay = 0;
            $(window).scroll(function() {
                clearTimeout(scrollDelay);

                scrollDelay = setTimeout(function() {
                    _this.scrollDetect($(this).scrollTop());
                }, 150);
            });
        }
    },
    beforeDestroy() {
        $("body").removeClass("lightBack scrolledPage aboutPage");
    }
};
</script>

<style lang="stylus" scoped>
.mission {
    padding: 81px 0 100px 0;
    color: #000;

    @media (min-width: 1024px) {
        display: grid;
        grid-template-rows: repeat(2, min-width);
        grid-template-columns: repeat(2, 346px);
        grid-gap: 48px 142px;
        justify-content: center;
    }
}

.mission__wrap:not(:last-child) {
    margin-bottom: 48px;

    @media (min-width: 1024px) {
        margin: 0;
    }
}

.mission__title {
    margin-bottom: 16px;
}

.mission__text {
    margin: 0;
}
</style>